 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "static/js/" + ({"QywxLayout":"QywxLayout","bankcard":"bankcard","cart":"cart","checkPiece~checkResult~custom~index~placeOrder":"checkPiece~checkResult~custom~index~placeOrder","checkPiece":"checkPiece","checkResult":"checkResult","custom~orderGoods~placeOrder":"custom~orderGoods~placeOrder","custom":"custom","placeOrder":"placeOrder","login":"login","index":"index","settledApply":"settledApply","coupon":"coupon","orderGoods":"orderGoods","evaluate":"evaluate","integral":"integral","kuaizhipei":"kuaizhipei","loginLayout":"loginLayout","main":"main","myHome":"myHome","myaddress":"myaddress","mycoupon":"mycoupon","myhelp":"myhelp","myorder":"myorder","newsDetails~newsList~productDetails":"newsDetails~newsList~productDetails","newsDetails":"newsDetails","newsList":"newsList","productDetails":"productDetails","orderdetails~settlement":"orderdetails~settlement","orderdetails":"orderdetails","settlement":"settlement","password":"password","privacyAgreement":"privacyAgreement","productList":"productList","qywxOrderDetails":"qywxOrderDetails","returndetails":"returndetails","returngoods":"returngoods","returnlist":"returnlist","serviceAgreement":"serviceAgreement","wallet":"wallet","wechat":"wechat"}[chunkId]||chunkId) + "." + {"QywxLayout":"67c1c0b7","bankcard":"cdb454ab","cart":"e057f4ff","checkPiece~checkResult~custom~index~placeOrder":"33a030d5","checkPiece":"9fecd886","checkResult":"41afb506","custom~orderGoods~placeOrder":"9d7c8a44","custom":"237fd69c","placeOrder":"d5c41f5e","login":"dfbbd77b","index":"c0085d7b","chunk-226e7622":"6a8f2679","settledApply":"2e42fa49","coupon":"11c2ca8b","orderGoods":"eb0de0dd","evaluate":"b863426a","integral":"9279bec3","kuaizhipei":"014aea0e","loginLayout":"5702a70a","main":"e342a69b","myHome":"31203b94","myaddress":"17c93c49","mycoupon":"8b81fd6e","myhelp":"e4245974","myorder":"2ca44578","newsDetails~newsList~productDetails":"45883702","newsDetails":"171d12d2","newsList":"af20380c","productDetails":"c49856c7","orderdetails~settlement":"7c061cf4","orderdetails":"3de8ff8a","settlement":"d50440fb","password":"ba8dad84","privacyAgreement":"5362c4bc","productList":"7e09d69b","qywxOrderDetails":"bca9d9ee","returndetails":"261074f7","returngoods":"ca5a22ba","returnlist":"769bab6b","serviceAgreement":"de575c7c","wallet":"5c37ac11","wechat":"89935b32","chunk-54e49730":"0dd24967","chunk-fda8067a":"df4cb483"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"QywxLayout":1,"bankcard":1,"cart":1,"checkPiece":1,"checkResult":1,"custom~orderGoods~placeOrder":1,"custom":1,"placeOrder":1,"login":1,"index":1,"settledApply":1,"coupon":1,"orderGoods":1,"evaluate":1,"integral":1,"kuaizhipei":1,"loginLayout":1,"main":1,"myHome":1,"myaddress":1,"mycoupon":1,"myhelp":1,"myorder":1,"newsDetails~newsList~productDetails":1,"newsDetails":1,"newsList":1,"productDetails":1,"orderdetails":1,"settlement":1,"password":1,"privacyAgreement":1,"productList":1,"qywxOrderDetails":1,"returndetails":1,"returngoods":1,"returnlist":1,"serviceAgreement":1,"wallet":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "static/css/" + ({"QywxLayout":"QywxLayout","bankcard":"bankcard","cart":"cart","checkPiece~checkResult~custom~index~placeOrder":"checkPiece~checkResult~custom~index~placeOrder","checkPiece":"checkPiece","checkResult":"checkResult","custom~orderGoods~placeOrder":"custom~orderGoods~placeOrder","custom":"custom","placeOrder":"placeOrder","login":"login","index":"index","settledApply":"settledApply","coupon":"coupon","orderGoods":"orderGoods","evaluate":"evaluate","integral":"integral","kuaizhipei":"kuaizhipei","loginLayout":"loginLayout","main":"main","myHome":"myHome","myaddress":"myaddress","mycoupon":"mycoupon","myhelp":"myhelp","myorder":"myorder","newsDetails~newsList~productDetails":"newsDetails~newsList~productDetails","newsDetails":"newsDetails","newsList":"newsList","productDetails":"productDetails","orderdetails~settlement":"orderdetails~settlement","orderdetails":"orderdetails","settlement":"settlement","password":"password","privacyAgreement":"privacyAgreement","productList":"productList","qywxOrderDetails":"qywxOrderDetails","returndetails":"returndetails","returngoods":"returngoods","returnlist":"returnlist","serviceAgreement":"serviceAgreement","wallet":"wallet","wechat":"wechat"}[chunkId]||chunkId) + "." + {"QywxLayout":"5428b353","bankcard":"c15f6a8d","cart":"6a5551b6","checkPiece~checkResult~custom~index~placeOrder":"31d6cfe0","checkPiece":"2da02e72","checkResult":"cb19db33","custom~orderGoods~placeOrder":"936203ce","custom":"1638ea20","placeOrder":"7d87380b","login":"da50e90c","index":"d29b55cd","chunk-226e7622":"31d6cfe0","settledApply":"653cfbd6","coupon":"7158c6a0","orderGoods":"1feba2c8","evaluate":"d2ff4885","integral":"84d5e944","kuaizhipei":"44f2bcc4","loginLayout":"1abaf8fc","main":"fe2b4f56","myHome":"535245e5","myaddress":"9fb1e1cf","mycoupon":"7158c6a0","myhelp":"45e06c12","myorder":"39d1bbc8","newsDetails~newsList~productDetails":"119d931a","newsDetails":"c7a19290","newsList":"c7a19290","productDetails":"116c974c","orderdetails~settlement":"31d6cfe0","orderdetails":"137288b5","settlement":"7d02e244","password":"da50e90c","privacyAgreement":"ee79f58e","productList":"767ef40d","qywxOrderDetails":"984fe731","returndetails":"8928c0c7","returngoods":"b0ae3fa1","returnlist":"cc783b6d","serviceAgreement":"7cf1e7c7","wallet":"05481123","wechat":"31d6cfe0","chunk-54e49730":"31d6cfe0","chunk-fda8067a":"31d6cfe0"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/pc/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
